import { applySpec, path, map, compose, omit } from 'ramda'

import { Question, Strongest, Argument, Builder } from '../../../selectors'
import { User } from 'modules/user'

export const serializeGameResult = (state, argumentId) => {
  const question = compose(path(['question']), Question.current)
  const argument = compose(
    ({ id, imgUrl, text }) => ({
      argumentId: id,
      imgUrl,
      text
    }),
    Argument.selected(argumentId)
  )
  const argumentParts = compose(map(omit(['x', 'y', 'dirty'])), Builder.parts)

  return applySpec({
    question,
    strongestArgumentPartIndex: Strongest.selected,
    argument,
    argumentParts,
    tcLogin: User.email,
    classCode: User.courseCode
  })(state)
}



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Preview/utils.js